<template>
  <div class="right">
    <div class="right-top">
      <div class="title right-top-title">{{Year}}年销量排行</div>
      <div class="bar" v-for="(item, index) in RankList" :key="index">

        <div class="right-top-text">
          <span>{{item.salesNum}}</span>
          <span>(吨)</span>
        </div>
        <div :class="item.cxx">
          <img :src="item.image" alt />
          <el-progress :percentage="item.salesRate"></el-progress>
          <span class="name font-fam-SM font-size14">{{item.name}}</span>
        </div>
      </div>
    </div>
    <Center />
    <Bottom />
  </div>
</template>
<script>
import Center from "./Center/index";
import Bottom from "./Bottom/index";
import Img1 from "../../assets/bgIcon/trophy1.png";
import Img2 from "../../assets/bgIcon/trophy2.png";
import Img3 from "../../assets/bgIcon/trophy3.png";

export default {
  components: {
    Center,
    Bottom,
  },
  data() {
    return {
      Year: 2019,
      RankList: [],
      icons: [Img1, Img2, Img3]
    };
  },
  mounted() {
    this.getSalesRanking()
  },

  methods:{
    async getSalesRanking() {
      let res = await this.$axios.get("bigdata/index/getSalesRanking")
      if(res.status === 200 && res.data.code === "1" && res.data.salesRanking.length > 0) {
          this.RankList = [];
          this.Year = res.data.salesRanking[0].dataYear;
          let maxSales = res.data.salesRanking[0].sales;
          let css = ["progress-bar progress-bar1", "progress-bar progress-bar2", "progress-bar progress-bar3"];

          for(let i = 0; i < res.data.salesRanking.length; ++i)
          {
            let item = res.data.salesRanking[i];
            this.RankList.push({"name": item.unitName, "salesNum": item.sales, "salesRate": 100*item.sales/maxSales, "cxx": css[i%3], "image": this.icons[i%3]})
          }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.right {
  position: absolute;
  left: 1396px;
  top: -38px;
  .right-top {
    width: 514px;
    height: 233px;
    background: url("../../assets/bgIcon/cell.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    padding-top: 35px;
    box-sizing: border-box;
    .right-top-title{
      position: absolute;
      top: -5px;
    }
    .bar{
      padding-top: 10px;
    }
    .right-top-text {
      font-family: OPPOSans-B;
      font-weight: Bold;
      color: #ffffff;
      font-size: 14px;
      line-height: 14px;
      margin-left: 73px;
    }
    .progress-bar {
      display: flex;
      margin-left: 32px;
      align-items: center;

      .el-progress {
        width: 332px;
        height: 20px;
        margin: 0 20px 0 16px;
      }
    }
    .progress-bar1 /deep/.el-progress-bar__inner {
      background-image: linear-gradient(to right, #00eaff, #61fde5);
    }
    .progress-bar2 /deep/.el-progress-bar__inner {
      background-image: linear-gradient(to right, #e7dc61, #e9f27c);
    }
    .progress-bar3 /deep/.el-progress-bar__inner {
      background-image: linear-gradient(to right, #7c93f2, #61b0e7);
    }
  }


}
</style>
<style lang='scss'>
.el-progress-bar {
  height: 20px;
  .el-progress-bar__outer {
    width: 332px !important;
    height: 20px !important;
    border-radius: 0px !important;
    overflow: hidden;
    position: relative;
    vertical-align: middle;
    background:rgba(40,133,152,0.5);
    .el-progress-bar__inner {
      border-radius: 0px !important;
    }
  }
}
.el-progress__text {
  display: none !important;
}
</style>
